import { faArrowDownToBracket } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, BoxProps, Button, Flex, Heading, Image, Text } from '@modusign/design-system';

import { EXCEL_DOWNLOAD_URL, MAX_CONTACT_COUNT } from '@app/features/addressBook/constants';
import useContactsCount from '@app/features/addressBook/hooks/useContactsCount';

import ExcelUploadDropZone from '../ExcelUploadDropZone';
import ExcelExampleImage from './excel-example.png';

export default function ExcelUploadPageContent() {
  const { data } = useContactsCount();

  const excelUploadableCount = MAX_CONTACT_COUNT - (data?.count ?? 0);

  return (
    <Box maxWidth="xmd" mx="auto" pb={10} pt={7}>
      <Box mb={9}>
        <Flex alignItems="center" gap={2} mb={7}>
          <CircleStep step="1" />
          <Heading fontSize="md" fontWeight="bold">
            입력용 엑셀 다운로드
          </Heading>
        </Flex>
        <Box bg="boxBackgroundNeutralBase" p={9}>
          <Text as="p" color="textNeutralSlightlyLight">
            입력용 엑셀 파일에 추가할 연락처 정보를 입력해 주세요.
          </Text>

          <Box my={7}>
            <Image height="200px" src={ExcelExampleImage} width="420px" />
          </Box>

          <Button
            variant="subtle"
            onClick={() => {
              window.open(EXCEL_DOWNLOAD_URL, '_blank', 'noopener,noreferrer');
            }}
          >
            엑셀 파일 다운로드{' '}
            <Box as="span" ml={2}>
              <FontAwesomeIcon icon={faArrowDownToBracket} />
            </Box>
          </Button>
        </Box>
      </Box>

      <Box>
        <Flex alignItems="center" gap={2} mb={7}>
          <CircleStep step="2" />
          <Heading fontSize="md" fontWeight="bold">
            엑셀 업로드
          </Heading>
          <Text color="textNeutralLight" fontSize="md">
            (추가 가능한 연락처 :{' '}
            <Text color="textEmphasisBase" fontSize="md" fontWeight="medium">
              {excelUploadableCount.toLocaleString()}개
            </Text>
            )
          </Text>
        </Flex>
        <ExcelUploadDropZone />
      </Box>
    </Box>
  );
}

interface CircleStepProps extends BoxProps<'div'> {
  step: string;
}

function CircleStep({ step, ...props }: CircleStepProps) {
  return (
    <Box
      bg="statusBackgroundPrimaryBase"
      borderRadius="50%"
      fontSize="xxs"
      fontWeight="bold"
      height="21px"
      position="relative"
      width="21px"
      {...props}
    >
      <Text
        as="p"
        fontSize="xxs"
        fontWeight="bold"
        sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
      >
        {step}
      </Text>
    </Box>
  );
}
